// UK date formatting helpers (DD/MM/YYYY). Safe for ISO strings ("2026-07-26"),
// full ISO datetimes, or Date objects. Returns the original value if unparseable.
export function ukDate(value) {
  if (!value) return "—";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/); // ISO date or datetime -> avoid tz shift
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const d = new Date(s);
  return isNaN(d.getTime()) ? s : d.toLocaleDateString("en-GB");
}

// British date + time (DD/MM/YYYY HH:mm) for logs/audits.
export function ukDateTime(value) {
  if (!value) return "—";
  const d = new Date(String(value));
  if (isNaN(d.getTime())) return ukDate(value);
  return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
}


// Short British day/month (DD/MM) for narrow contexts like table column headers.
export function ddmm(value) {
  if (!value) return "";
  const s = String(value);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}/${m[2]}`;
  const d = new Date(s);
  return isNaN(d.getTime()) ? s : `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`;
}
